import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import HomePage from "@/pages/homePageV2/homePageComponents/HomePage";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { PageNamesEnum } from "@/routes/routes";
import useFullLoading from "@hooks/useFullLoading";
import useIsIOS from "@hooks/useIsIOS";
function Home() {
  var fullPageData = useFullPageData(PageNamesEnum.PAGE_NAME__Home);
  if (!fullPageData) return null;
  var loading = useFullLoading();
  var isIos = useIsIOS();
  return /*#__PURE__*/React.createElement(Layout, {
    headHideLinks: true,
    hideOrangeHeadBtn: true,
    hasNavBar: true,
    pageName: "home",
    hasMobFooter: true,
    loading: loading,
    disableLoader: true,
    hasContactUs: true,
    authenticationMsg: true,
    hideHeadOnScroll: true,
    showUserAvatar: true,
    hideDownloadBanner: isIos
  }, /*#__PURE__*/React.createElement(HomePage, {
    data: fullPageData.homeDataNew
  }));
}
export default Home;